import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment-taxi-directo';
// import { io, Socket } from 'socket.io-client';
import * as io from 'socket.io-client';
import { Observable } from 'rxjs';
import { ObserversModule } from '@angular/cdk/observers';
import { HttpClient } from '@angular/common/http';
import { connect } from 'http2';

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {
  socket: any;

  constructor(private _http: HttpClient) {}

  connect() {
    // this.socket = io('http://localhost:3000', {
    //   secure: false
    // });
    // this.socket = io('https://reporte-directo.nexusvirtual.net', {
    //   secure: true,
    //   path: '/tracking-directo/'
    // });

    this.socket = io(environment.URL_NOTIFICACIONES, {
      secure: true,
      rejectUnauthorized: false,
      path: environment.PATH_TRACKING
    });
  }

  deactivateUser(IdCliente: number) {
    this.socket.emit('deactivate', { IdCliente: IdCliente });
  }

  deactivateUserWari(Usuario: string) {
    this.socket.emit('deactivateUsuario', { Usuario: Usuario });
  }

  recieveDeactivatedUser() {
    return new Observable((observer) => {
      this.socket.on('deactivate', (message) => {
        observer.next(message);
      });
    });
  }

  receiveUpdate() {
    return new Observable((observer) => {
      this.socket.on('updateweb', (message) => {
        observer.next(message);
      });
    });
  }
}